import { get } from 'lodash-es'

let isStandalone: boolean | undefined = undefined

export function isLaunchedAsStandaloneApp() {
	if (isStandalone === undefined) {
		const navigator: unknown = window.navigator
		isStandalone = get(navigator, 'standalone') || window.matchMedia('(display-mode: standalone)').matches
	}

	return isStandalone
}
